import axios from '../../axios/index.js'
import store from '../../../store/store.js'

// Token Refresh
let isAlreadyFetchingAccessToken = false
let subscribers = []

function onAccessTokenFetched (access_token) {
  subscribers = subscribers.filter(callback => callback(access_token))
}

function addSubscriber (callback) {
  subscribers.push(callback)
}

export default {
  init () {
    axios.interceptors.response.use(function (response) {
      return response
    }, function (error) {
      // const { config, response: { status } } = error
      const { config, response } = error
      const originalRequest = config

      // if (status === 401) {
      if (response && response.status === 401) {
        if (!isAlreadyFetchingAccessToken) {
          isAlreadyFetchingAccessToken = true
          store.dispatch('auth/fetchAccessToken')
            .then((access_token) => {
              isAlreadyFetchingAccessToken = false
              onAccessTokenFetched(access_token)
            })
        }

        const retryOriginalRequest = new Promise((resolve) => {
          addSubscriber(access_token => {
            originalRequest.headers.Authorization = `Bearer ${access_token}`
            resolve(axios(originalRequest))
          })
        })
        return retryOriginalRequest
      }
      return Promise.reject(error)
    })
  },
  getPropertyList (payload) {
    const token = localStorage.accessToken

    return axios.get('/api/property/propertyList', {
      params: {
        user_group : payload.user_group
      },
      headers:{
        Authorization: `Bearer ${token}`
      }
    })
  },
  getSectionList (payload) {
    const token = localStorage.accessToken
    return axios.get('/api/product/section/list', {
      params: {
        restaurantId : payload.restaurantId
      },
      headers:{
        Authorization: `Bearer ${token}`
      }
    })
  },
  getSizeList (payload) {
    const token = localStorage.accessToken
    return axios.get('/api/product/size/list', {
      params: {
        restaurantId : payload.restaurantId
      },
      headers:{
        Authorization: `Bearer ${token}`
      }
    })
  },
  getProduct (payload) {
    const token = localStorage.accessToken
    return axios.get('/api/product/item/getProduct', {
      params: payload,
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
  },
  getRestaurant (payload) {
    const token = localStorage.accessToken
    return axios.get('/api/customer/restaurant/getRestaurant', {
      params: payload,
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
  },
  getProductList (payload) {
    const token = localStorage.accessToken
    const params = {
      restaurantId : payload.restaurantId
    }
    if (payload.q) {
      params.q = payload.q
    }
    return axios.get('/api/product/item/productList', {
      params,
      headers:{
        Authorization: `Bearer ${token}`
      }
    })
  },
  getProductListAll () {
    const token = localStorage.accessToken
    return axios.get('/api/product/item/productListAll', {
      headers:{
        Authorization: `Bearer ${token}`
      }
    })
  },
  getModifierList (payload) {
    const token = localStorage.accessToken
    return axios.get('/api/product/modifier/list', {
      params: {
        restaurantId : payload.restaurantId
      },
      headers:{
        Authorization: `Bearer ${token}`
      }
    })
  },
  uploadImage (payload, onUploadProgress) {
    const token = localStorage.accessToken
    const formData = new FormData()

    formData.append('file', payload.file)
    formData.append('productId', payload.productId)

    return axios.post('/api/product/item/productImageSave', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': `Bearer ${token}`
      },
      onUploadProgress
    })

  },
  uploadLogo (payload, onUploadProgress) {
    const token = localStorage.accessToken
    const formData = new FormData()

    formData.append('property[Logo]', payload.file)
    formData.append('user_id', payload.restaurantId)

    return axios.post('/api/user/userSave', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': `Bearer ${token}`
      },
      onUploadProgress
    })

  },
  uploadImageProfile (payload, onUploadProgress) {
    const token = localStorage.accessToken
    const formData = new FormData()

    formData.append('file', payload.file)
    formData.append('restaurantId', payload.restaurantId)


    return axios.post('/api/user/profileImageSave', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': `Bearer ${token}`
      },
      onUploadProgress
    })

  },
  getPropertyTypes () {
    const token = localStorage.accessToken
    return axios.get('/api/property/propertyTypes', {
      headers:{
        Authorization: `Bearer ${token}`
      }
    })
  },
  addModifier (payload) {
    const token = localStorage.accessToken
    return axios.post('/api/product/modifier/addModifier', payload, {
      headers:{
        Authorization: `Bearer ${token}`
      }
    })
  },
  addProduct (payload) {

    const token = localStorage.accessToken
    return axios.post('/api/product/item/addProduct', payload, {
      headers:{
        Authorization: `Bearer ${token}`
      }
    })
  },
  addSection (payload) {
    const token = localStorage.accessToken
    return axios.post('/api/product/section/addSection', payload, {
      headers:{
        Authorization: `Bearer ${token}`
      }
    })
  },
  addProperty (payload) {
    const token = localStorage.accessToken
    return axios.post('/api/property/propertySave', payload, {
      headers:{
        Authorization: `Bearer ${token}`
      }
    })
  },
  addSize (payload) {
    const token = localStorage.accessToken
    return axios.post('/api/product/size/addSize', payload, {
      headers:{
        Authorization: `Bearer ${token}`
      }
    })
  },
  removeProperty (payload) {
    const token = localStorage.accessToken
    return axios.delete('/api/property/deleteProperty', {
      headers:{
        Authorization: `Bearer ${token}`
      },
      data: payload
    })
  },
  removeProduct (payload) {
    const token = localStorage.accessToken
    return axios.delete('/api/product/item/deleteProduct', {
      headers:{
        Authorization: `Bearer ${token}`
      },
      data: payload
    })
  },
  removeProductImage (payload) {
    const token = localStorage.accessToken
    return axios.delete('/api/product/item/deleteProductImage', {
      headers:{
        Authorization: `Bearer ${token}`
      },
      data: payload
    })
  },
  removeModifier (payload) {
    const token = localStorage.accessToken
    return axios.delete('/api/product/modifier/deleteModifier', {
      headers:{
        Authorization: `Bearer ${token}`
      },
      data: payload
    })
  },
  removeSize (payload) {
    const token = localStorage.accessToken
    return axios.delete('/api/product/size/deleteSize', {
      headers:{
        Authorization: `Bearer ${token}`
      },
      data: payload
    })
  },
  removeSection (payload) {
    const token = localStorage.accessToken
    return axios.delete('/api/product/section/deleteSection', {
      headers:{
        Authorization: `Bearer ${token}`
      },
      data: payload
    })
  },
  removeUser (payload) {
    const token = localStorage.accessToken
    return axios.delete('/api/user/deleteUser', {
      headers:{
        Authorization: `Bearer ${token}`
      },
      data: payload
    })
  },
  saveUser (payload) {
    const token = localStorage.accessToken

    return axios.post('/api/user/userSave', payload, {
      headers:{
        Authorization: `Bearer ${token}`
      }
    })
  },
  cateringSendRestaurant (payload) {
    const token = localStorage.accessToken

    return axios.post(`/api/caterings/${  payload.cateringOrderId}/offers`, payload, {
      headers:{
        Authorization: `Bearer ${token}`
      }
    })
  },
  duplicateUser (payload) {
    const token = localStorage.accessToken

    return axios.post('/api/user/duplicateProducts', payload, {
      headers:{
        Authorization: `Bearer ${token}`
      }
    })
  },
  getUserList (payload) {
    const token = localStorage.accessToken
    return axios.get('/api/user/userList', {
      params: payload,
      headers:{
        Authorization: `Bearer ${token}`
      }
    })
  },
  getContentList (payload) {
    const token = localStorage.accessToken
    return axios.get('/api/content/contentList', {
      params: payload,
      headers:{
        Authorization: `Bearer ${token}`
      }
    })
  },
  getProfile () {
    const token = localStorage.accessToken
    return axios.get('/api/user/profile', {
      headers:{
        Authorization: `Bearer ${token}`
      }
    })
  },
  getCampaignList (payload) {
    const token = localStorage.accessToken
    return axios.get('/api/content/campaignList', {
      headers:{
        Authorization: `Bearer ${token}`
      },
      params: payload
    })
  },
  removeContent (payload) {
    const token = localStorage.accessToken
    return axios.delete('/api/content/deleteContent', {
      headers:{
        Authorization: `Bearer ${token}`
      },
      data: payload
    })
  },
  checkToken (payload) {
    const token = localStorage.accessToken
    return axios.post('/api/auth/loginCheck', payload, {
      headers:{
        Authorization: `Bearer ${token}`
      }
    })
  },
  addContent (payload, onUploadProgress) {
    const token = localStorage.accessToken
    const contentForm = new FormData()

    if (payload.contentImage) {
      contentForm.append('contentImage', payload.contentImage)
    }
    if (payload.contentId) {
      contentForm.append('contentId', payload.contentId)
    }

    contentForm.set('contentType', payload.contentType)
    contentForm.set('longContent', payload.longContent)
    contentForm.set('shortContent', payload.shortContent)
    contentForm.set('restaurant_id', payload.restaurant_id)
    contentForm.set('name', payload.name)
    contentForm.append('restaurants', JSON.stringify(payload.restaurants))
    return axios.post('/api/content/saveContent', contentForm, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': `Bearer ${token}`
      },
      onUploadProgress
    })

  },
  setRestaurantStatus (payload) {
    const token = localStorage.accessToken

    return axios.post('/api/hour/TakingOrders', payload, {
      headers:{
        Authorization: `Bearer ${token}`
      }
    })

  },
  getOrderList (payload) {
    const token = localStorage.accessToken
    return axios.get('/api/order/orderList', {
      params: payload,
      headers:{
        Authorization: `Bearer ${token}`
      }
    })
  },
  getCateringOrderList (payload) {
    const token = localStorage.accessToken
    return axios.get('/api/caterings', {
      params: payload,
      headers:{
        Authorization: `Bearer ${token}`
      }
    })
  },
  getCateringOrderOfferList (payload) {
    const token = localStorage.accessToken
    return axios.get(`/api/caterings/${payload.cateringOrderId}/offers`, {
      params: payload,
      headers:{
        Authorization: `Bearer ${token}`
      }
    })
  },
  getOrder (payload) {
    const token = localStorage.accessToken
    return axios.get('/api/order/getOrder', {
      params: payload,
      headers:{
        Authorization: `Bearer ${token}`
      }
    })
  },
  getCateringOrder (payload) {
    const token = localStorage.accessToken
    return axios.get(`/api/caterings/${  payload.cateringOrderId}`, {
      headers:{
        Authorization: `Bearer ${token}`
      }
    })
  },
  getWeeklyHours (payload) {
    const token = localStorage.accessToken
    return axios.get('/api/hour/weeklyHours', {
      params: payload,
      headers:{
        Authorization: `Bearer ${token}`
      }
    })
  },
  saveWeeklyHours (payload) {
    const token = localStorage.accessToken

    return axios.post('/api/hour/editWeeklyHours', payload, {
      headers:{
        Authorization: `Bearer ${token}`
      }
    })
  },
  getOrderStatusList () {
    const token = localStorage.accessToken
    return axios.get('/api/order/statusList', {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
  },
  setOrderStatus (payload) {
    const token = localStorage.accessToken
    return axios.put('/api/order/orderStatusChange', payload, {
      headers:{
        Authorization: `Bearer ${token}`
      }
    })
  },
  setCateringOrderStatus (payload) {
    const token = localStorage.accessToken
    return axios.put('/api/caterings/orderStatusChange', payload, {
      headers:{
        Authorization: `Bearer ${token}`
      }
    })
  },
  arrangeSection (payload) {
    const token = localStorage.accessToken
    return axios.put('/api/product/section/arrangeSection', payload, {
      headers:{
        Authorization: `Bearer ${token}`
      }
    })
  },
  getCouponList (payload) {
    const token = localStorage.accessToken
    return axios.get('/api/coupon/couponList', {
      params: payload,
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
  },
  setCoupon (payload) {
    const token = localStorage.accessToken
    return axios.post('/api/coupon/couponSave', payload, {
      headers:{
        Authorization: `Bearer ${token}`
      }
    })
  },
  removeCoupon (payload) {
    const token = localStorage.accessToken

    return axios.delete('/api/coupon/deleteCoupon', {
      headers:{
        Authorization: `Bearer ${token}`
      },
      data: payload
    })
  },
  setBoundry (payload) {
    const token = localStorage.accessToken
    return axios.post('/api/deliveryBoundaries/boundarySave', payload, {
      headers:{
        Authorization: `Bearer ${token}`
      }
    })
  },
  setBoundryZipcode (payload) {
    const token = localStorage.accessToken
    return axios.post('/api/deliveryBoundaries/boundaryZipCodeAdd', payload, {
      headers:{
        Authorization: `Bearer ${token}`
      }
    })
  },
  getBoundaryList (payload) {
    const token = localStorage.accessToken
    return axios.get('/api/deliveryBoundaries/boundaryList', {
      params: payload,
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
  },
  getBoundary (payload) {
    const token = localStorage.accessToken
    return axios.get('/api/deliveryBoundaries/getBoundary', {
      params: payload,
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
  },
  removeZipcodeBoundary (payload) {
    const token = localStorage.accessToken
    return axios.delete('/api/deliveryBoundaries/boundaryZipCodeDelete', {
      headers:{
        Authorization: `Bearer ${token}`
      },
      data: payload
    })
  },
  removeBoundary (payload) {
    const token = localStorage.accessToken
    return axios.delete('/api/deliveryBoundaries/boundaryDelete', {
      headers:{
        Authorization: `Bearer ${token}`
      },
      data: payload
    })
  },
  forgotPassword (payload) {
    return axios.post('/api/customer/user/forgotPassword', payload)
  },
  resetPassword (payload) {
    return axios.post('/api/customer/user/resetPassword', payload)
  },
  verifyMail (payload) {
    const token = localStorage.accessToken
    return axios.post('/api/customer/user/verify-new-email', payload, {
      headers:{
        Authorization: `Bearer ${token}`
      }
    })
  },
  changePassword (payload) {
    const token = localStorage.accessToken
    return axios.post('/api/user/changePassword', payload, {
      headers:{
        Authorization: `Bearer ${token}`
      }
    })
  },
  changeUserPassword (payload) {
    const token = localStorage.accessToken
    return axios.post('/api/user/change-user-password', payload, {
      headers:{
        Authorization: `Bearer ${token}`
      }
    })
  },
  login (payload) {
    //this.apitest()
    return axios.post('/api/auth/login', payload)
  },
  getStripeAccount (payload) {
    const token = localStorage.accessToken
    return axios.get('/api/user/getStripeAccount', {
      params: payload,
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
  },
  getStripeTransfers (payload) {
    const token = localStorage.accessToken
    return axios.get('/api/user/getStripeTransfers', {
      params: payload,
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
  },
  getMonthlyInvoices (payload) {
    const token = localStorage.accessToken
    return axios.get('/api/user/getMonthlyInvoices', {
      params: payload,
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
  },
  getWeeklyInvoices (payload) {
    const token = localStorage.accessToken
    return axios.get('/api/user/getWeeklyInvoices', {
      params: payload,
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
  },
  addBankAccount (payload) {
    const token = localStorage.accessToken
    return axios.get('/api/user/addBankAccount', {
      params: payload,
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
  },
  createStripeAccount (payload) {
    const token = localStorage.accessToken
    return axios.post('/api/user/createStripeAccount', payload, {
      headers:{
        Authorization: `Bearer ${token}`
      }
    })
  },

  getEvent (payload) {
    const token = localStorage.accessToken
    return axios.get('/api/event/getEvent', {
      params: payload,
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
  },

  addEvent (payload) {
    const token = localStorage.accessToken
    return axios.post('/api/event/saveEvent', payload, {
      headers:{
        Authorization: `Bearer ${token}`
      }
    })
  },

  removeEvent (payload) {
    const token = localStorage.accessToken
    return axios.delete('/api/event/deleteEvent', {
      headers:{
        Authorization: `Bearer ${token}`
      },
      data: payload
    })
  },


  eventList (payload) {
    const token = localStorage.accessToken
    return axios.get('/api/event/eventList', {
      params: payload,
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
  },
  addRestaurantSale (payload) {
    const token = localStorage.accessToken
    return axios.post('/api/restaurant-sales', payload,  {
      headers:{
        Authorization: `Bearer ${token}`
      }
    })
  },
  restaurantSales (payload) {
    const token = localStorage.accessToken
    return axios.get('/api/restaurant-sales', {
      params: payload,
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
  }
}
